import React from "react";
import Lotto12Nav from "../../components/lotto12/Lotto12Nav";
import Dashboard from "../../components/lotto12/Dashboard";
import MainDrawingWrapper from "../../components/lotto12/MainDrawingWrapper";
import {useLotto12} from "../../store/lotto12/Lotto12Context";

const Lotto12Dashboard = () => {
    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="wrapper-new-keno">
                        <MainDrawingWrapper>
                            <Lotto12Nav/>
                            <DashboardWrapper/>
                        </MainDrawingWrapper>
                    </div>
                </div>
            </div>
        </div>
    );
};

const DashboardWrapper = () => {
    const lotto = useLotto12();
    return <Dashboard {...lotto} />;
};

export default Lotto12Dashboard;
